<template>
	<div class="content-wrapper">
		<div
			v-if="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
			v-html="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
		/>
		<div class="ce-table rs-table">
			<div v-for="tableitem in objectdata.tableitems" :key="tableitem.id" class="rs-table-row">
				<div>{{tableitem[0]}}</div>
				<!-- <div>{{tableitem[1]}}</div> -->
				<div v-bind:inner-html.prop="tableitem[1] | nl2br"/>
			</div>
		</div>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},
		data() {
			return {};
		}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";
</style>